export class WebhookWizard extends HTMLElement {
  constructor(close) {
    super();
    this.close = close;
  }

  connectedCallback() {
    this.innerHTML = `
      <style>
        .next-webhook-wizard { margin-left: 10px; }
        #webhook_steps {margin-top: 20px;}
        .webhook-wizard-actions {margin-top: 20px;}
      </style>
      <div class="row">
        <div class="col-md-8 col-sm-12 col-md-offset-2">
          <h3><span id="campaign-back" class="close-webhook-wizard"></span> Create Integration</h3> 

          <div class="row">
            <div class="col-sm-12">
              <wizard-steps></wizard-steps>
            </div>
          </div>
          <div id="webhook_steps">
          </div>
          
        </div>
      </div>`

    let webhook_steps = this.querySelector("#webhook_steps");
    let wizard_steps = this.querySelector("wizard-steps")

    
    this.integration_step1 = new IntegrationStep1(() => {
      this.integration_step1.classList.add("hidden");
      this.webhook_wizard_step1.classList.remove("hidden");
    }, 
    () => {
      this.integration_step1.classList.add("hidden");
      this.email_wizard_step1.classList.remove("hidden")
      this.showStep(1, WebhookWizard.EMAIL);
    });
    webhook_steps.appendChild(this.integration_step1)

    this.webhook_wizard_step1 = new WebhookWizardStep1((data)=>{
      wizard_steps.setStep(2);
      this.webhook_wizard_step1.classList.add("hidden");
      if(data.new_template) {
        this.webhook_wizard_step2.setData(data);
        this.webhook_wizard_step2.classList.remove("hidden");
      } else {
        this.webhook_wizard_step3.setData(data);
        this.webhook_wizard_step3.classList.remove("hidden");
      }
    }, this.showStep.bind(this));
    this.webhook_wizard_step1.classList.add("hidden");
    webhook_steps.appendChild(this.webhook_wizard_step1)

    this.webhook_wizard_step2 = new WebhookWizardStep2(() => {
        wizard_steps.setStep(1);
        this.webhook_wizard_step2.classList.add("hidden");
        this.webhook_wizard_step1.classList.remove("hidden");
      },
      (data) => {
        wizard_steps.setStep(3);
        this.webhook_wizard_step2.classList.add("hidden");
        this.webhook_wizard_step3.setData(data);
        this.webhook_wizard_step3.classList.remove("hidden");
      });
    
    this.webhook_wizard_step2.classList.add("hidden");
    webhook_steps.appendChild(this.webhook_wizard_step2)

    this.webhook_wizard_step3 = new WebhookWizardStep3((data)=>{
      wizard_steps.setStep(data.new_template ? 4 : 3);
      this.webhook_wizard_step3.classList.add("hidden");
      this.webhook_wizard_step4.setData(data);
      this.webhook_wizard_step4.classList.remove("hidden");
    }, (step) => {
      wizard_steps.setStep(step);
      this.webhook_wizard_step3.classList.add("hidden");
      if(step == 1) {
        this.webhook_wizard_step1.classList.remove("hidden");
      } else {
        this.webhook_wizard_step2.classList.remove("hidden");
      }
    });

    this.webhook_wizard_step3.classList.add("hidden");
    webhook_steps.appendChild(this.webhook_wizard_step3)

    this.webhook_wizard_step4 = new WebhookWizardStep4(() => {
      wizard_steps.setStep(3);
      this.webhook_wizard_step4.classList.add("hidden");
      this.webhook_wizard_step3.classList.remove("hidden");
    },
    (data) => {
      this.save(data);
    });
    this.webhook_wizard_step4.classList.add("hidden");
    webhook_steps.appendChild(this.webhook_wizard_step4)

    this.email_wizard_step1 = new EmailWizardStep1(() => {}, (data) => {
      this.email_wizard_step2.setData(data)
      wizard_steps.setStep(2);
      this.email_wizard_step1.classList.add("hidden");
      this.email_wizard_step2.classList.remove("hidden");
    });
    this.email_wizard_step1.classList.add("hidden")
    webhook_steps.appendChild(this.email_wizard_step1)

    this.email_wizard_step2 = new EmailWizardStep2(() => {
      this.email_wizard_step2.classList.add("hidden");
      this.email_wizard_step1.classList.remove("hidden");
    },
    (data) => {
      this.saveEmailIntegration(data);
    });
    this.email_wizard_step2.classList.add("hidden")
    webhook_steps.appendChild(this.email_wizard_step2)

    this.querySelectorAll(".close-webhook-wizard").forEach( (item) => { item.addEventListener('click', ()=> {
        this.close();
        this.remove();
      }
    )});
  }

  showStep(step, stepsType) {
    let webhook_steps = this.querySelector("wizard-steps");
    let progressbar = this.querySelector(".progressbar");

    if(stepsType == WebhookWizard.WEBHOOK_NEW) {
      webhook_steps.showNewSteps();
    }

    if(stepsType == WebhookWizard.WEBHOOK_EXISTING) {
      webhook_steps.hideNewSteps();
    }

    if(stepsType == WebhookWizard.EMAIL) {
      webhook_steps.showEmailSteps();
    }

    
    webhook_steps.setStep(step);
  }

  async save(data) {
    let domain_id = document.querySelector("#object_id").value
    let webhook = {
      name: data.name,
      action_type: "WEBHOOK",
      domain_id: domain_id,
      params: [
          {name: "success_code", value: data.response_code},
          {name: "headers", value: JSON.stringify(data.http_headers)},
          {name: "url", value: data.url},
          {name: "method", value: data.http_method}
        ]
    };
    if(data.new_template) {
      webhook.template = {
        name: data.template_name,
        template_type: data.template_type,
        template: data.processed_template
      }
    } else {
      webhook.action_template_id = data.template_id;
    }
    

    let res = await fetch('/admin/actions', {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'POST',
      body: JSON.stringify(webhook)
    })
    let response = await res.json();
    let data_binder = new DataBinder("/admin/domains/"+domain_id+"/actions", true);
    data_binder.fetchData();

    if(data.new_template) {
      let templates_binder = new DataBinder(`/admin/domains/${domain_id}/action_templates/webhooks`, true);
      templates_binder.fetchData();
    }

    this.close();
    this.remove();
  }

  async saveEmailIntegration(data) {
    let domain_id = document.querySelector("#object_id").value
    let webhook = {
      name: data.name,
      action_type: "EMAIL",
      domain_id: domain_id,
      action_template_id: data.template.value,
      params: [
          {name: "email_subject", value: data.email_subject},
          {name: "email_recipients", value: data.email_recipients},
          {name: "email_template_alias", value: "GENERIC_EMAIL"}
        ]
    };

    let res = await fetch('/admin/actions', {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'POST',
      body: JSON.stringify(webhook)
    })
    let response = await res.json();
    let data_binder = new DataBinder("/admin/domains/"+domain_id+"/actions", true);
    data_binder.fetchData();

    if(data.new_template) {
      let templates_binder = new DataBinder(`/admin/domains/${domain_id}/action_templates/webhooks`, true);
      templates_binder.fetchData();
    }

    this.close();
    this.remove();
  }
}

WebhookWizard.WEBHOOK_NEW = "WEBHOOK_NEW";
WebhookWizard.WEBHOOK_EXISTING = "WEBHOOK_EXISTING";
WebhookWizard.EMAIL = "EMAIL";

customElements.define('webhook-wizard', WebhookWizard)


class IntegrationStep1 extends HTMLElement {
  constructor(webhookWizard, emailWizard) {
    super();
    this.new_template = false;
    this.webhookWizard = webhookWizard;
    this.emailWizard = emailWizard;
  }

  connectedCallback() {
    this.innerHTML = `
          <style>
            #webhook-integration-btn:hover, #email-integration-btn:hover {
              background-color: #E7F0FE;  
            }

            #webhook-integration-btn, #email-integration-btn {
              cursor: pointer;
            }


          </style>
          <div class="row" id="template-selection">
            <div class="col-md-4 col-sm-12 col-md-offset-2">
              <div id="email-integration-btn" class="templates-btn">
                <p>Create Email Integration</p><span class="fa fa-file fa-lg"></span>
              </div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div id="webhook-integration-btn" class="templates-btn">
                <p>Create Webhook Integration</p><span class="fa fa-pencil-square-o fa-lg"></span>
              </div>
            </div>
          </div>
        </div>
    `;

    this.querySelector("#webhook-integration-btn").addEventListener("click", this.webhookWizard)
    this.querySelector("#email-integration-btn").addEventListener("click", this.emailWizard)
  }

  activateNav() {
    this.querySelector(".next-webhook-wizard").removeAttribute("disabled");
    this.querySelector(".previous-webhook-wizard").removeAttribute("disabled");
  }
}
customElements.define('integration-wizard-step-1', IntegrationStep1)


class WebhookWizardStep1 extends HTMLElement {
  constructor(nextStep, changeNav) {
    super();
    this.new_template = false;
    this.nextStep = nextStep;
    this.changeNav = changeNav;
  }

  connectedCallback() {
    let domain_id = document.querySelector("#object_id").value
    this.innerHTML = `
          <style>
            #existing-templates-btn:hover, #new-templates-btn:hover,
            #existing-templates-btn.selected, #new-templates-btn.selected {
              background-color: #E7F0FE;  
            }

            #new-templates-btn, #existing-templates-btn {
              cursor: pointer;
            }

            .webhooks-existing-template-fields .new-template-field {
              display: none;
            }

            .webhooks-new-template-fields .existing-template-field {
              display: none;
            }
          </style>
          <div class="row" id="template-selection">
            <div class="col-md-4 col-sm-12 col-md-offset-2">
              <div id="existing-templates-btn" class="templates-btn">
                <p>Select from Existing Templates</p><span class="fa fa-file fa-lg"></span>
              </div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div id="new-templates-btn" class="templates-btn">
                <p>Create Template</p><span class="fa fa-pencil-square-o fa-lg"></span>
              </div>
            </div>
          </div>  

          <div id="webhook-wizard-settings" class="hidden">
            <div class="form-group">
              <label>Webhook Name</span></label>
              <input type="text" class="form-control webhook_name" data-required="true" placeholder="Webhook Name">
            </div>
            <div class="form-group">
              <label>URL</span></label>
              <input type="text" class="form-control webhook_url" data-required="true" data-validate="url" placeholder="example: http://mydomain.com/?param=mystaticparam">
            </div>
            <div class="form-group existing-template-field">
              <label>Template</span></label>
              <select class="form-control existing_webhook_template" data-required="true" is="webhook-template-select" data-selected="" data-domain_id=${domain_id}>
              </select>
            </div>
            <div class="form-group new-template-field">
              <label>Template Name</label>
              <input type="text" class="form-control template_name" placeholder="Template Name" data-required="true">
            </div>
            <div class="form-group new-template-field">
              <label>Template Type</span></label>
              <select class="form-control webhook_format" data-required="true">
                <option>JSON</option>
                <option>XML</option>
              </select>
            </div>
            <div class="form-group new-template-field">
              <label>Copy and Paste your Template</span></label>
              <textarea id="webhook_template" style="width: 100%; height: 250px; overflow-y: scroll; resize: none;" data-required="true"></textarea>
            </div>
          </div>
        </div>

        <div class="row webhook-wizard-actions"> 
          <div class="col-md-6 no-gutters"> 
            <a class="btn btn-outline-secondary close-webhook-wizard">Cancel</a>
          </div>
          <div class="col-md-6 no-gutters"> 
            <a class="btn btn-primary pull-right next-webhook-wizard" disabled>Next</a>
            <a class="btn btn-outline-secondary pull-right previous-webhook-wizard" disabled>Previous</a>
          </div>
        </div>
    `;

    let webhook_settings = this.querySelector("#webhook-wizard-settings")
    this.querySelector("#existing-templates-btn").addEventListener("click", function(e) {
      this.new_template = false;
      this.querySelector("#existing-templates-btn").classList.add("selected");
      webhook_settings.classList.remove("hidden", "webhooks-new-template-fields");
      webhook_settings.classList.add("webhooks-existing-template-fields")
      this.querySelector("#new-templates-btn").classList.remove("selected");
      this.activateNav();
      this.changeNav(1, WebhookWizard.WEBHOOK_EXISTING);
    }.bind(this));

    this.querySelector("#new-templates-btn").addEventListener("click", function(e) {
      this.new_template = true;
      this.querySelector("#new-templates-btn").classList.add("selected");
      webhook_settings.classList.remove("hidden", "webhooks-existing-template-fields");
      webhook_settings.classList.add("webhooks-new-template-fields")
      this.querySelector("#existing-templates-btn").classList.remove("selected");
      this.activateNav();
      this.changeNav(1, WebhookWizard.WEBHOOK_NEW);
    }.bind(this));

    this.querySelector(".previous-webhook-wizard").addEventListener("click", function(e) {
      webhook_settings.classList.remove("webhooks-existing-template-fields", "webhooks-new-template-fields");
      webhook_settings.classList.add("hidden");
      this.disableNav();
      this.changeNav(0);
    }.bind(this));

    this.querySelector(".next-webhook-wizard").addEventListener("click", function(e) {
      let result = this.validateStep()
      if(result.is_valid) {
        this.nextStep(result.data);
      }
    }.bind(this));
  }

  activateNav() {
    this.querySelector(".next-webhook-wizard").removeAttribute("disabled");
    this.querySelector(".previous-webhook-wizard").removeAttribute("disabled");
  }

  disableNav() {
    this.querySelector(".next-webhook-wizard").setAttribute("disabled", "disabled");
    this.querySelector(".previous-webhook-wizard").setAttribute("disabled", "disabled");
  }

  validateStep() {
    let data = {}
    let is_valid = true;

    data.name = this.querySelector(".webhook_name").value.trim();
    if(data.name.length == 0) {
      is_valid = false;
      Common.notify("Please enter a Webhook Name.", "error");
    }

    data.url = this.querySelector(".webhook_url").value.trim(); 
    var pattern = new RegExp('^(https?:\\/\\/)'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    if(data.url.length == 0 || !pattern.test(data.url)) {
      is_valid = false;
      Common.notify("Please enter a valid URL.", "error");
    }

    if(this.new_template) {
      data.template_name = this.querySelector(".template_name").value.trim();
      if(data.template_name.length == 0) {
        is_valid = false;
        Common.notify("Please enter a template name.", "error");
      }

      data.template = this.querySelector("#webhook_template").value.trim();
      if(data.template.length == 0) {
        is_valid = false;
        Common.notify("Please enter a template.", "error");
      } else {
        data.new_template = true;
        data.template_type = this.querySelector(".webhook_format").value
        if(data.template_type == "JSON") {
          if(!WebhookUtils.validateJSON(data.template)) {
            is_valid = false;
            Common.notify("JSON is invalid.", "error");
          }
        } else if (!WebhookUtils.validateXML(data.template)) {
          is_valid = false;
          Common.notify("XML is invalid.", "error");
        }
      }
    } else {
      data.new_template = false;
      let webhook_template_select = this.querySelector(".existing_webhook_template")
      data.template_id = webhook_template_select.value;
      data.template_name = webhook_template_select.options[webhook_template_select.selectedIndex].text
      data.template_type = webhook_template_select.options[webhook_template_select.selectedIndex].getAttribute("data-template_type")
      if(data.template_id == "") {
        is_valid = false;
        Common.notify("Please select a template.", "error");
      }
    }

    return {is_valid: is_valid, data: data};
  }
}
customElements.define('webhook-wizard-step-1', WebhookWizardStep1)

class WebhookWizardStep2 extends HTMLElement {
  constructor(prevStep, nextStep) {
    super();
    this.prevStep = prevStep;
    this.nextStep = nextStep;
  }

  connectedCallback() {
    this.innerHTML = `<div id="custom_template_data">
                <table style="width:100%" class="table">
                  <thead>
                    <td>Data Point Path</td>
                    <td>Current Value</td>
                    <td>Replace With</td>
                  </thead>
                  <tbody>
                            
                  </tbody>
                </table>
              </div>
              <div class="row webhook-wizard-actions"> 
                <div class="col-md-6 no-gutters"> 
                  <a class="btn btn-outline-secondary close-webhook-wizard" id="cancel-webhook-wizard">Cancel</a>
                </div>
                <div class="col-md-6 no-gutters"> 
                  <a class="btn btn-primary pull-right next-webhook-wizard">Next</a>
                  <a class="btn btn-outline-secondary pull-right previous-webhook-wizard">Previous</a>
                </div>
              </div>

              `;

    this.custom_template_data_table = $("#custom_template_data table").DataTable({
              select: false, 
              search: false,
              paging: false,
              dom: "<t>",
              bSort : false,
              columns: [
                { data : "data_path",
                  render: function ( data, type, row ) {
                            return data;
                        }},
                { data : "data_value", "visible" : true},
                { "visible" : true,
                  render: function ( data, type, row ) {
                            return `<select class="replace_select" data-path="${row.data_path}" is="template-token-select"></select>`;
                        }}
                ]
              });

    this.querySelector(".previous-webhook-wizard").addEventListener("click", function(e) {
      this.prevStep();
    }.bind(this));

    this.querySelector(".next-webhook-wizard").addEventListener("click", function(e) {
      let result = this.validateStep()
      if(result.is_valid) {
        this.nextStep(result.data);
      }
    }.bind(this));
  }

  validateStep() {
    //processJSONTemplate
    if(this.data.template_type == "JSON") {
      this.data.processed_template = WebhookUtils.processJSONTemplate(this.data.template)
    } else {
      this.data.processed_template = WebhookUtils.processXMLTemplate(this.data.template)
    }
    return {is_valid: true, data: this.data};
  }

  setData(data) {
    this.data = data;

    this.custom_template_data_table.clear();
    for(let d=0; d < WebhookUtils.custom_template_data_paths.length; d++) {
      let new_row = {
        data_path: WebhookUtils.custom_template_data_paths[d].path,
        data_value: WebhookUtils.custom_template_data_paths[d].value
      };
      this.custom_template_data_table.row.add(new_row).draw( false );
    }
  }
} 
customElements.define('webhook-wizard-step-2', WebhookWizardStep2)

class WebhookWizardStep3 extends HTMLElement {
  constructor(nextStep, prevStep) {
    super();
    this.nextStep = nextStep;
    this.prevStep = prevStep;
  }

  setData(data) {
    this.data = data;
    this.querySelector(".header_name").value = "Content-Type";
    if(data.template_type == "JSON") {
      this.querySelector(".header_value").value = "application/json";
    } else {
      this.querySelector(".header_value").value = "application/xml";
    }
  }

  connectedCallback() {
    this.innerHTML = `
          <style>
            .webhook_http_headers > div:only-child .remove_webhook_http_headers {
              display: none;
            }

            .webhook_http_headers > div .add_webhook_http_headers {
              display: none;
            }

            .webhook_http_headers > div:last-child .add_webhook_http_headers {
              display: inline-block;
            }
          </style>
          <div id="webhook-wizard-advanced">

            <div class="form-group">
              <div class="row">
                <div class="col-md-5 no-gutters">
                    <label>HTTP Header</label>
                </div>
                <div class="col-md-4">
                    <label>Value</label>
                </div>
              </div>
              <div class="webhook_http_headers">
                
              </div>
            </div>

            <div class="form-group">
              <label>Success Response Code</span></label>
              <select class="form-control success_response_code">
                <option>200</option>
                <option>201</option>
                <option>202</option>
                <option>203</option>
                <option>204</option>
              </select> 
            </div>

            <div class="form-group">
              <label>HTTP Method</span></label>
              <select class="form-control http_method">
                <option value="POST">POST</option>
                <option value="PUT">PUT</option>
              </select> 
            </div>
          </div>
        </div>

        <div class="row webhook-wizard-actions"> 
          <div class="col-md-6 no-gutters"> 
            <a class="btn btn-outline-secondary close-webhook-wizard" id="cancel-webhook-wizard">Cancel</a>
          </div>
          <div class="col-md-6 no-gutters"> 
            <a class="btn btn-primary pull-right next-webhook-wizard">Next</a>
            <a class="btn btn-outline-secondary pull-right previous-webhook-wizard">Previous</a>
          </div>
        </div>
    `

    this.addHeader();

    this.querySelector(".previous-webhook-wizard").addEventListener("click", function(e) {
      if(this.data.is_new_template) {
        this.prevStep(2);
      } else {
        this.prevStep(1);
      }
      
    }.bind(this));

    this.querySelector(".next-webhook-wizard").addEventListener("click", function(e) {
      let result = this.validateStep()
      if(result.is_valid) {
        this.nextStep(result.data);
      }
    }.bind(this));
  }

  addHeader() {
    let new_header = document.createElement("div");
    new_header.classList.add("row", "form-group")
    new_header.innerHTML = `
                  <div class="col-md-5 no-gutters">
                      <input type="text" class="form-control header_name" placeholder="HTTP Header Name" />
                  </div>
                  <div class="col-md-6">
                      <input type="text" class="form-control header_value" placeholder="Value" />
                  </div>
                  <div class="col-md-1" style="line-height:30px;">
                    <a class="remove_webhook_http_headers"><span class="fa fa-minus"></span></a>
                    <a class="add_webhook_http_headers"><span class="fa fa-plus"></span></a>
                  </div>`
    this.querySelector(".webhook_http_headers").appendChild(new_header);
    new_header.querySelector(".remove_webhook_http_headers").addEventListener("click", () => new_header.remove());
    new_header.querySelector(".add_webhook_http_headers").addEventListener("click", () => this.addHeader());
  }

  validateStep() {
    this.data.response_code = this.querySelector(".success_response_code").value;
    this.data.http_method = this.querySelector(".http_method").value;

    this.data.http_headers = {};
    this.querySelectorAll(".webhook_http_headers .form-group").forEach((elem) => {
      this.data.http_headers[elem.querySelector(".header_name").value] = elem.querySelector(".header_value").value;
    });

    return {is_valid: true, data: this.data}
  }
}
customElements.define('webhook-wizard-step-3', WebhookWizardStep3)

class WebhookWizardStep4 extends HTMLElement {
  constructor(prevStep, save) {
    super();
    this.save = save;
    this.prevStep = prevStep;
  }

  connectedCallback() {
    this.innerHTML = `
      <style>
        webhook-wizard-step-4 .panel {
          padding: 30px;
          font-size: 16px;
        }
        webhook-wizard-step-4 .panel .row {
          margin-bottom: 10px;
        }
      </style>
      <div class="panel">
        <div class="row">
          <div class="col-md-6 webhook-label">Name:</div>
          <div class="col-md-6 webhook-name-value"></div>
        </div>
        <div class="row">
          <div class="col-md-6 webhook-label">URL:</div>
          <div class="col-md-6 webhook-url-value"></div>
        </div>
        <div class="row">
          <div class="col-md-6 webhook-label">Template:</div>
          <div class="col-md-6 webhook-template-value"></div>
        </div>
        <div class="row">
          <div class="col-md-6 webhook-label">Headers:</div>
          <div class="col-md-6 webhook-headers-value"></div>
        </div>
        <div class="row">
          <div class="col-md-6 webhook-label">Success Code:</div>
          <div class="col-md-6 webhook-success-code-value"></div>
        </div>
        <div class="row">
          <div class="col-md-6 webhook-label">HTTP Method:</div>
          <div class="col-md-6 webhook-method-value"></div>
        </div>
      </div>

      <div class="row webhook-wizard-actions"> 
        <div class="col-md-6 no-gutters"> 
          <a class="btn btn-outline-secondary close-webhook-wizard" id="cancel-webhook-wizard">Cancel</a>
        </div>
        <div class="col-md-6 no-gutters"> 
          <a class="btn btn-primary pull-right next-webhook-wizard">Save</a>
          <a class="btn btn-outline-secondary pull-right previous-webhook-wizard">Prev</a>
        </div>
      </div>
    `;
    this.querySelector(".next-webhook-wizard").addEventListener("click", () => {
      this.save(this.data);
    });

    this.querySelector(".previous-webhook-wizard").addEventListener("click", function(e) {
      this.prevStep();
    }.bind(this));
  }

  setData(data) {
    this.data = data;
    this.querySelector(".webhook-name-value").innerHTML = data.name;
    this.querySelector(".webhook-url-value").innerHTML = data.url;
    this.querySelector(".webhook-template-value").innerHTML = data.template_name;
    let header_values = this.querySelector(".webhook-headers-value");
    Object.entries(data.http_headers).forEach((header)=> {
      let header_div = document.createElement("div");
      header_div.innerHTML = `${header[0]}:${header[1]}`;
      header_values.appendChild(header_div);
    });

    this.querySelector(".webhook-success-code-value").innerHTML = this.data.response_code;
    this.querySelector(".webhook-method-value").innerHTML = this.data.http_method;
  }
}
customElements.define('webhook-wizard-step-4', WebhookWizardStep4)


class EmailWizardStep1 extends HTMLElement {
  constructor(prevStep, nextStep) {
    super();
    this.prevStep = prevStep;
    this.nextStep = nextStep;
  }

  connectedCallback() {
    let domain_id = document.querySelector("#object_id").value
    this.innerHTML = `
              <div id="custom_template_data">
                <div class="form-group">
                  <label>Email Name</span></label>
                  <input type="text" class="form-control email_name" data-required="true" placeholder="Email Name">
                </div>
                <div class="form-group existing-template-field">
                  <label>Template</span></label>
                  <select class="form-control existing_webhook_template" data-required="true" is="webhook-template-select" data-selected="" data-domain_id=${domain_id}>
                  </select>
                </div>
                <div class="form-group email-subject">
                  <label>Email Subject</label>
                  <input type="text" class="form-control email_subject" placeholder="Email Subject" data-required="true">
                </div>
                <div class="form-group">
                  <label>Email Integration Recipients</label>
                  <textarea class="form-control email_integration_recipients" placeholder="Please separate email addresses by using a comma"></textarea>
                </div>
              </div>
              <div class="row webhook-wizard-actions"> 
                <div class="col-md-6 no-gutters"> 
                  <a class="btn btn-outline-secondary close-webhook-wizard" id="cancel-webhook-wizard">Cancel</a>
                </div>
                <div class="col-md-6 no-gutters"> 
                  <a class="btn btn-primary pull-right next-webhook-wizard">Next</a>
                </div>
              </div>

              `;

    this.querySelector(".next-webhook-wizard").addEventListener("click", () => {
      let template_elem = this.querySelector(".existing_webhook_template");
      if(this.validate()) {
        this.data = {
          name: this.querySelector(".email_name").value,
          template: {
            name: template_elem.options[template_elem.selectedIndex].text,
            value: template_elem.value
          },
          email_subject: this.querySelector(".email_subject").value,
          email_recipients: this.querySelector(".email_integration_recipients").value
        }
        this.nextStep(this.data);
      }
    });
  }

  validate() {
    let is_valid = true;
    if(this.querySelector(".email_name").value.trim().length == 0) {
      Common.notify("Please enter a Email Name.", "error");
      is_valid = false;
    }

    if(this.querySelector(".existing_webhook_template").value == "") {
      Common.notify("Please select a template.", "error");
      is_valid = false;
    }

    if(this.querySelector(".email_subject").value.trim().length == 0) {
      Common.notify("Please select a Email Subject.", "error");
      is_valid = false;
    }

    if(this.querySelector(".email_integration_recipients").value.trim().length == 0) {
      Common.notify("Please enter Email Recipients.", "error");
      is_valid = false;
    }
    else if(!Common.validateCommaSeperatedEmail(this.querySelector(".email_integration_recipients").value)) {
      Common.notify("Email Recipients are invalid.", "error");
      is_valid = false;
    }

    return is_valid;
  }
} 
customElements.define('email-wizard-step-1', EmailWizardStep1)

class EmailWizardStep2 extends HTMLElement {
  constructor(prevStep, nextStep) {
    super();
    this.prevStep = prevStep;
    this.nextStep = nextStep;
  }

  connectedCallback() {
    let domain_id = document.querySelector("#object_id").value
    this.innerHTML = `
              <style>
                email-wizard-step-2 .panel {
                  padding: 30px;
                  font-size: 16px;
                }
                email-wizard-step-2 .panel .row {
                  margin-bottom: 10px;
                }
              </style>
              <div class="panel">
                <div class="row">
                  <div class="col-md-6 webhook-label">Name:</div>
                  <div class="col-md-6 email-name-value"></div>
                </div>
                <div class="row">
                  <div class="col-md-6 webhook-label">Template:</div>
                  <div class="col-md-6 email-template"></div>
                </div>
                <div class="row">
                  <div class="col-md-6 webhook-label">Subject:</div>
                  <div class="col-md-6 email-subject"></div>
                </div>
                <div class="row">
                  <div class="col-md-6 webhook-label">Recipients:</div>
                  <div class="col-md-6 email-recipients"></div>
                </div>
              </div>
              <div class="row webhook-wizard-actions"> 
                <div class="col-md-6 no-gutters"> 
                  <a class="btn btn-outline-secondary close-webhook-wizard" id="cancel-webhook-wizard">Cancel</a>
                </div>
                <div class="col-md-6 no-gutters"> 
                  <a class="btn btn-primary pull-right next-webhook-wizard">Save</a>
                  <a class="btn btn-primary pull-right prev-webhook-wizard">Previous</a>
                </div>
              </div>

              `;

    this.querySelector(".prev-webhook-wizard").addEventListener("click", this.prevStep)
    this.querySelector(".next-webhook-wizard").addEventListener("click", ()=>{this.nextStep(this.data)})
  }

  setData(data) {
    this.data = data;
    this.querySelector(".email-name-value").innerHTML = this.data.name
    this.querySelector(".email-template").innerHTML = this.data.template.name;
    this.querySelector(".email-subject").innerHTML = this.data.email_subject;
    this.querySelector(".email-recipients").innerHTML = this.data.email_recipients;
  }
} 
customElements.define('email-wizard-step-2', EmailWizardStep2)


class WebhookTemplateSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.template = document.createElement('template');
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;

    let json_options = this.data.filter(template => template.template_type == "JSON").map(template => `<option value="${template.action_template_id}" data-template_type="${template.template_type}">${template.name}</option>`)
    let xml_options = this.data.filter(template => template.template_type == "XML").map(template => `<option value="${template.action_template_id}" data-template_type="${template.template_type}">${template.name}</option>`)
    let text_options = this.data.filter(template => template.template_type == "TEXT").map(template => `<option value="${template.action_template_id}" data-template_type="${template.template_type}">${template.name}</option>`)
    this.template.innerHTML =`
      <option value="">Select</option>
      ${json_options.length > 0 ? `<optgroup label="JSON">${json_options.join("")}</optgroup>` : ``}
      ${xml_options.length > 0 ? `<optgroup label="XML">${xml_options.join("")}</optgroup>` : ``}
      ${text_options.length > 0 ? `<optgroup label="Text">${text_options.join("")}</optgroup>` : ``}`
    
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    if(this.getAttribute("data-selected") != "") {
      this.value = this.getAttribute("data-selected");
    }
  }

  async connectedCallback() {
    let domain_id = this.getAttribute("data-domain_id")
    this.data_binder = new DataBinder(`/admin/domains/${domain_id}/action_templates/webhooks`, true);
    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }
}

customElements.define('webhook-template-select', WebhookTemplateSelect, {extends: 'select'});

class WizardSteps extends HTMLElement {
  constructor() {
    super();
  }

  setStep(step) {
    if(step == 0) {
      this.classList.add("hidden");
    } else {
      this.classList.remove("hidden");
      let currentActive = this.querySelector(".active")
      if(currentActive != null) {
        currentActive.classList.remove("active");
      }

      this.querySelectorAll("li")[step-1].classList.add("active");
    }
  }

  hideNewSteps() {
    this.querySelector(".progressbar").innerHTML = `
      <li style="width: 33%;">Basic Settings</li>
      <li style="width: 33%;">Advanced Settings</li>
      <li style="width: 33%;">Summary</li>
    `;
  }

  showNewSteps() {
    this.querySelector(".progressbar").innerHTML = `
      <li>Basic Settings</li>
      <li>Custom Data</li>
      <li>Advanced Settings</li>
      <li>Summary</li>
    `;
  }

  showEmailSteps() {
     this.querySelector(".progressbar").innerHTML = `
      <li style="width: 50%;">Basic Settings</li>
      <li style="width: 50%;">Summary</li>
    `;
  }

  connectedCallback() {
    this.innerHTML = `
      <style>
        #next-webhook-wizard { margin-left: 10px; }
        .progressbar {
          counter-reset: step;
        }

        .progressbar li {
          list-style-type: none;
          width: 25%;
          float: left;
          font-size: 14px;
          position: relative;
          text-align: center;
          color: #434A54;
        }

        .progressbar li:before {
          width: 30px;
          height: 30px;
          content: counter(step);
          counter-increment: step;
          line-height: 25px;
          border: 2px solid #E7F0FE;
          display: block;
          text-align: center;
          margin: 0 auto 10px auto;
          border-radius: 50%;
          background-color: #E7F0FE;
          color: #337AB7
        }

        .progressbar li:after {
          width: 100%;
          height: 1px;
          content: '';
          position: absolute;
          background-color: #337AB7;
          top: 15px;
          left: -50%;
          z-index: -1;
        }

        .progressbar li:first-child:after {
          content: none;
        }

        .progressbar li.active:before {
          content: counter(step);
        }

        .progressbar li.active ~ li {
          color: #434A54;
        }

        .progressbar li.active ~ li:before {
          background-color: #E5E5E5;
          border-color: #E5E5E5;
          content: counter(step);
          color: #434A54;
        }

        .progressbar li.active ~ li:after {
          background-color: #E5E5E5;
        }
      </style>
      <ul class="progressbar">
      </ul>
      `
    this.setStep(0)
  }
}

customElements.define('wizard-steps', WizardSteps);

let WebhookUtils = {
    custom_template_data_paths: null,
    validateJSON: function(json) {
      try {
        WebhookUtils.custom_template_data_paths = [];
        let jsonTemplateObj = JSON.parse(json);
        WebhookUtils.findJSONDescendants(jsonTemplateObj, "", WebhookUtils.custom_template_data_paths)
        console.log(WebhookUtils.custom_template_data_paths);
      } catch (e) {
        return false;
      }
      return true;
    },
    validateXML: function(xml) {
      var oParser = new DOMParser();
      var oDOM = oParser.parseFromString(xml, "text/xml");
      
      if (oDOM.getElementsByTagName('parsererror').length > 0) {
        return false;
      } else {
        WebhookUtils.custom_template_data_paths = [];
        let t = oDOM.childNodes
        for(let i = 0; i < t.length; i++) {
          if (t[i].nodeType == 1) {
            console.log("here")
            let new_path = "//" + t[i].nodeName;
            WebhookUtils.findXMLDescendants(t[i], new_path, WebhookUtils.custom_template_data_paths);
          }
        }
        console.log(WebhookUtils.custom_template_data_paths);
        return true;
      }
    },
    findJSONDescendants: function(object, path, descendants) {
      if(object == null) return;
      let objectKeys = Object.keys(object);
      if(objectKeys.length > 0) {
        for(let d=0; d < objectKeys.length; d++) {
          let newPath = (path.length > 0 ? path+"." : "") + objectKeys[d];
          if((typeof object[objectKeys[d]] == 'object')) {
            WebhookUtils.findJSONDescendants(object[objectKeys[d]], newPath, descendants);
          }
          else {
            descendants.push({path: newPath, value: object[objectKeys[d]]})
          }
        }
      }
    },
    findXMLDescendants: function(el, xpath, descendants) {
      var children = el.childNodes;

      // When you parse the XML you get text children between tags. These should be ignored.
      let hasRealChildTags = false;
      for(let d=0; d < children.length; d++) {
        console.log(children[d].nodeName);
        if (children[d].nodeType == 1) {
          hasRealChildTags = true;
        }
      }

      for(let d=0; d < children.length; d++) {
         if (children[d].nodeType == 1) {
            let new_path = xpath + "/" + children[d].nodeName;
            let attribute_list = children[d].attributes;
            for(let j=0; j < attribute_list.length; j++) {
              console.log(attribute_list[j]);
              descendants.push({path: new_path+"/@"+attribute_list[j].name, value: attribute_list[j].value});
            }
            WebhookUtils.findXMLDescendants(children[d], new_path, descendants)
         }
         else if (!hasRealChildTags) {
            descendants.push({path: xpath, value: children[d].nodeValue});
         }
      }
    },
    processJSONTemplate: function(template) {
      let jsonTemplateObj = JSON.parse(template);
      $(".replace_select").each(function(){
        let path = $(this).data("path");

        let value_to_set = $(this).val();
        if(value_to_set != "") {
          setJSONValue(path, value_to_set, jsonTemplateObj);
          function setJSONValue(path, val, obj) {
            let fields = path.split('.');
            let result = obj;
            for (var i = 0, n = fields.length; i < n && result !== undefined; i++) {
              var field = fields[i];
              if (i === n - 1) {
                result[field] = val;
              } else {
                if (typeof result[field] === 'undefined' || !_.isObject(result[field])) {
                  result[field] = {};
                }
                result = result[field];
              }
            }
          }
        }
      });
      let custom_template = JSON.stringify(jsonTemplateObj);

      // This tag needs to be treated in a special way as it is an array that gets inserted.
      custom_template = custom_template.replace('"%prompt_responses%"', '%prompt_responses%');
      return custom_template;
    },
    processXMLTemplate: function(template) {
      let oParser = new DOMParser();
      let oDOM = oParser.parseFromString(template, "text/xml");
      $(".replace_select").each(function(){
        let path = $(this).data("path");
        let value_to_set = $(this).val();

        if(value_to_set != "") {
          let xpath = path;
          let evaluator = new XPathEvaluator();
          let expression = evaluator.createExpression(xpath);
          let result = expression.evaluate(oDOM, XPathResult.FIRST_ORDERED_NODE_TYPE).singleNodeValue;
          result.textContent = value_to_set;
        }

        
      });
      let custom_template = new XMLSerializer().serializeToString(oDOM.documentElement);
      return custom_template;
    },
};

  class TemplateTokenSelect extends HTMLSelectElement {
    constructor() {
      super();
      this.template = document.createElement('template');
    }

    // NOT TESTED
    requestUpdate(data){

      this.data = data;

      let call_begin_options = this.data.filter((item) => item.category == "call_begin").map(token => `<option value="%${token.token_name}%">${token.description}</option>`).join("")
      let call_end_options = this.data.filter((item) => item.category == "call_end").map(token => `<option value="%${token.token_name}%">${token.description}</option>`).join("")
      let dni_options = this.data.filter((item) => item.category == "dni").map(token => `<option value="%${token.token_name}%">${token.description}</option>`).join("")
      let location_options = this.data.filter((item) => item.category == "location_info").map(token => `<option value="%${token.token_name}%">${token.description}</option>`).join("")

      this.template.innerHTML =`
      <option value="">No Change</option>
      <optgroup label="Call Begin">
      ${call_begin_options}
      </optgroup>
      <optgroup label="Call End">
      ${call_end_options}
      </optgroup>
      <optgroup label="DNI">
      ${dni_options}
      </optgroup>
      <optgroup label="Location">
      ${location_options}
      </optgroup>
      `
      let value = this.value;
      
      this.innerHTML = "";

      this.appendChild(this.template.content.cloneNode(true));
      this.value = value;
      if(this.selectedOptions.length == 0) {
        this.value = ""
      }
    }

    async connectedCallback() {
      let domain_id = document.querySelector("#object_id").value
      this.data_binder = new DataBinder("/admin/domains/"+domain_id+"/action_templates/template_tokens", true);
      this.data_binder.register(this);
      if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
    }

    disconnectedCallback(){
      this.data_binder.unregister(this);
    }
  }

  customElements.define('template-token-select', TemplateTokenSelect, {extends: 'select'});